var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Subject } from "rxjs";
import { createDataStore } from "@astronautlabs/datastore-firestore";
import { v4 as uuid } from 'uuid';
import { lazyConnection } from "./lazy-connection";
export class FirebaseChatSource {
    constructor(identifier, auth, notif, collectionPath) {
        this.identifier = identifier;
        this.auth = auth;
        this.notif = notif;
        this.collectionPath = collectionPath;
        this._messageSent = new Subject();
        this.messages = [];
        this.datastore = createDataStore();
        let subscription;
        this._messageReceived = lazyConnection({
            start: subject => {
                console.log(`[Banta] Subscribing to topic '${identifier}' in collection path '${collectionPath}'`);
                let maxCount = 200;
                subscription = this.datastore
                    .watchForChanges(`${collectionPath}/messages`, { order: { field: 'sentAt', direction: 'asc' }, limit: 100 })
                    .subscribe(changes => {
                    for (let change of changes) {
                        if (change.type === 'added') {
                            let message = change.document;
                            console.log(`[Banta] Received message:`);
                            console.dir(message);
                            this.messages.push(message);
                            subject.next(message);
                        }
                        else if (change.type === 'modified') {
                            let message = change.document;
                            let existingMessage = this.messages.find(x => x.id === message.id);
                            Object.assign(existingMessage, message);
                        }
                        else if (change.type === 'removed') {
                            let message = change.document;
                            console.log('removed item: ');
                            console.dir(message);
                            let index = this.messages.findIndex(x => x.id === message.id);
                            this.messages.splice(index, 1);
                        }
                    }
                    while (this.messages.length > maxCount)
                        this.messages.shift();
                });
            },
            stop: () => subscription.unsubscribe()
        });
    }
    get messageReceived() {
        return this._messageReceived;
    }
    get messageSent() {
        return this._messageSent;
    }
    send(message) {
        return __awaiter(this, void 0, void 0, function* () {
            let finalMessage = yield this.recordMessage(this.collectionPath, message);
            yield this.sendMentionNotifications(finalMessage);
            return finalMessage;
        });
    }
    extractMentions(message) {
        let set = new Set();
        let match = message.match(/@[A-Za-z0-9]+\b/g);
        if (!match)
            return [];
        message
            .match(/@[A-Za-z0-9]+\b/g)
            .map(x => x.slice(1))
            .forEach(x => set.add(x));
        return Array.from(set.keys());
    }
    sendMentionNotifications(message, skipUserIDs = []) {
        return __awaiter(this, void 0, void 0, function* () {
            // Find users mentioned...
            let mentions = this.extractMentions(message.message)
                .filter(x => x !== message.user.username);
            if (mentions.length > 20)
                mentions = mentions.slice(0, 20);
            let accounts = yield this.auth.getUsersByUsernames(mentions);
            accounts = accounts.filter(x => x && x.uid && !skipUserIDs.includes(x.uid));
            if (mentions.length > 0) {
                console.log(`Mentioned:`);
                console.dir(mentions);
                console.log(`Found:`);
                console.dir(accounts);
            }
            // Post mention notifications...
            try {
                yield Promise.all(accounts.map(mentioned => {
                    console.log(`Notifying ${mentioned.username} of mention...`);
                    this.notif.send({
                        type: 'mention',
                        recipientId: mentioned.uid,
                        message
                    });
                }));
            }
            catch (e) {
                console.error(`Caught error while trying to send mention notifications for new message (skipping):`);
                console.error(e);
            }
        });
    }
    recordMessage(topicPath, message) {
        return __awaiter(this, void 0, void 0, function* () {
            let id = uuid();
            message = Object.assign({}, message, {
                id,
                sentAt: Date.now()
            });
            yield Promise.all([
                this.datastore.update(`${topicPath}/messages/${id}`, message),
                this.datastore.update(`${topicPath}/counters/messages`, { value: this.datastore.sentinels.increment(1) })
            ]);
            return message;
        });
    }
}
//# sourceMappingURL=firebase-chat-source.js.map